import {
  AnyPartType,
  partTypeAccessory,
  partTypePackage,
  partTypeTire,
  partTypeWheel,
} from "../constants/partTypes";
import {
  AnyProductType,
  productTypeAccessory,
  productTypePackage,
  productTypeTire,
  productTypeWheel,
} from "../constants/productTypes";

const map = {
  [partTypeAccessory]: productTypeAccessory,
  [partTypePackage]: productTypePackage,
  [partTypeTire]: productTypeTire,
  [partTypeWheel]: productTypeWheel,
} as const;

export const getProductTypeFromPartType = (
  partType: AnyPartType
): AnyProductType => {
  const productType = map[partType];
  if (!productType) {
    throw new Error(`Unknown part type: ${partType}`);
  }
  return productType;
};
